module.exports = __webpack_public_path__ + "static/media/mobile-booking-calendar_2x.6c445989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/mobile-booking-calendar_2x.png
// module id = 1220
// module chunks = 27